export default {
  namespaced: true,

  state: () => {
    const stored = localStorage.getItem('user');
    let parsed = {};
    
    if (stored) {
      try {
        parsed = JSON.parse(stored);
      } catch (e) {
        localStorage.removeItem('user');
      }
    }

    return {
      token: parsed.token || null,
      user: parsed.user || null,
      master: parsed.master || false,
      id: parsed.id || false,
    };
  },

  mutations: {
    SET_AUTH(state, payload) {
      state.token = payload.token;
      state.user = payload.user;
      state.master = payload.master;
      state.id = payload.id;

      const dataToStore = {
        token: payload.token,
        user: payload.user,
        master: payload.master,
        id: payload.id,
      };

      localStorage.setItem('user', JSON.stringify(dataToStore));
    },

    LOGOUT(state) {
      state.token = null;
      state.user = null;
      state.master = false;
      state.id = null;
      localStorage.removeItem('user');
    },
  },

  actions: {
    login({ commit }, { token, user, master, id }) {
      commit('SET_AUTH', { token, user, master, id });
    },

    logout({ commit }) {
      commit('LOGOUT');
    },

    checkAuth({ commit }) {
      const stored = localStorage.getItem('user');

      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed.token && parsed.user) {
          commit('SET_AUTH', parsed);
          return;
        }
      }

      commit('LOGOUT');
    },
  },

  getters: {
    isAuthenticated: (state) => !!state.token,
    user: (state) => state.user,
    isMaster: (state) => !!state.master,
    userId: (state) => state.id,
  },
};
